import axios from "../plugins/parseAxios";
export class UserAPI {
  constructor(props) { }
  
  static getUserOTP(payload) {
    return axios.post("functions/getUserOTP", payload);
  }
  static loginUserOTP(payload) {
    return axios.post("functions/loginUserOTP", payload);
  }
}
